import * as React from 'react';
import { Col, Row } from 'reactstrap';
import cl4 from 'src/assets/homeOperation/cl4.png';
import cl5 from 'src/assets/homeOperation/cl5.png';
import cl1 from 'src/assets/homeOperation/Client1.png';
import cl1xs from 'src/assets/homeOperation/Client1xs.png';
import cl2 from 'src/assets/homeOperation/Client2.png';
import cl2xs from 'src/assets/homeOperation/Client2xs.png';
import cl3 from 'src/assets/homeOperation/Shared3.png';

export const HomeOperationClient: React.SFC<{}> = () => (
  <>
{/************************  Ligne 1  ******************************/}
    <Row className='d-flex justify-content-center'>
      <Col sm='4' xs='12' className='d-flex mt-4 mt-sm-auto px-0  ' >
          <span  >
            <svg style={{marginBottom: '9px'}}  height="219"  width='5' className='d-none d-sm-block'>
              <line  x1="0" y1="0" x2="0"  y2="400" stroke-linecap="square" stroke="rgb(188, 235, 253)" stroke-width="11"  />
          </svg>
         </span>
          <svg height='5'  className='mt-auto d-none d-sm-block' style={{marginBottom: '9px'}}  >
            <line  x1="0" y1="0" x2="300" y2="0" stroke-linecap="square" stroke="rgb(188, 235, 253)" stroke-width="11"  />
          </svg>
        
          <img className='mt-auto mx-auto mx-sm-0 d-none d-sm-block' height="180" width="auto"  src={cl1}/>
          <img className='mt-auto mx-auto mx-sm-0 d-sm-none' height="180" width="auto"  src={cl1xs}/>

          <svg height='5' className='mt-auto d-none d-sm-block'>
            <line  x1="0" x2="1000" y1="0" y2="0" stroke-linecap="square" stroke="rgb(188, 235, 253)" stroke-width="11"  />
          </svg>
 
      </Col>
      <Col sm='4' xs='12' className='d-flex flex-column mt-3 px-0 '>
        <p style={{ backgroundColor: 'rgba(255,255,255, 0.5)' }} className='HomeOperationClientTextLn1' >  
          Vous avez une{' '} <strong className='text-secondary'>idée à développer</strong> , <br/>
          un projet précis à mettre en place. <br/>
          <strong className='text-secondary'>Inscrivez-vous</strong> en quelques clics et <strong className='text-secondary'>déposez</strong><br/>
          votre recherche de mission ou{' '} <strong className='text-secondary'>votre projet</strong>.
        </p>
          <svg style={{marginLeft:'-40px'  }} className='w-120 mt-auto  d-none d-sm-block' height='5'>
            <line  x1="0" x2="1000" y1="0" y2="0" stroke-linecap="square" stroke="#c5eaff" stroke-width="10"  />
          </svg>
      </Col>
    
    </Row>

{/************************  Ligne 2  ******************************/}
    <Row className='d-flex justify-content-center align-items-end'>
      
      <Col sm='4' xs='12' className='order-2 order-sm-1 mt-3 mt-sm-0 px-0 '>
        <Row className='px-0  mx-0 w-100 d-flex justify-content-center'>

          <Col className='d-flex px-0 justify-content-center'>
            <p  className='HomeOperationClientTextLn2' style={{ backgroundColor: 'rgba(255,255,255, 0.5)'}}>
              Les équipes BeAdvize{' '} <strong className='text-secondary'>vous contactent</strong> rapidement pour{' '}
              <strong className='text-secondary'>définir avec vous vos besoins</strong> 
              ,  <br/>vous orienter sur les technologies, les best-practices du secteur et{' '}
              <strong className='text-secondary'>construire avec vous</strong> une
              roadmap et un budget adéquat.
            </p>
          </Col>

        </Row>

        <Row className='d-flex mx-0 px-0'>
            <Col sm='3' className='px-0'/>
            <Col sm='9' className='px-0' >
              <svg  className='mt-auto d-none d-sm-block w-100'  height='5' >
                <line  x1="0" x2="800" y1="0" y2="0" stroke-linecap="square" stroke="#c5eaff" stroke-width="10"  />
              </svg>
            </Col>
        </Row>

      </Col>

      <Col sm='4' xs='12' className='d-flex justify-content-center order-1 order-sm-2 mt-5 mt-sm-auto px-0  '>
         
        <svg  /* style={{marginLeft:'-50px'}} */ className='mt-auto d-none d-sm-block' height='5' >
          <line  x1="0" x2="200" y1="0" y2="0" stroke-linecap="square" stroke="#c5eaff" stroke-width="10"  />
        </svg>
        
        <img className='mt-auto  d-none d-sm-block'  width='auto' height='170px' src={cl2}/>
        <img className='mt-auto d-sm-none' width='auto' height='170px' src={cl2xs}/>
        
        <svg  /* style={{marginLeft:'-95px'  }} */ className='mt-auto d-none d-sm-block' height='6'  >
          <line  x1="0" x2="400" y1="0" y2="0" stroke-linecap="square" stroke="#c5eaff" stroke-width="12"  />
        </svg>
        <span>
          <svg  height='228'  width='5'  className='d-none d-sm-block' >
            <line x1="0" x2="0" y1="0" y2="500" stroke-linecap="square" stroke="#c5eaff" stroke-width="10"  />
          </svg>
        </span>
      </Col>
    </Row>

  {/************************  Ligne 3  ******************************/}   
    <Row className='d-flex justify-content-center' >
      
      
      <Col sm='4' xs='12' className='d-flex mt-5 mt-sm-0 px-0  '>
        <Col sm='3' className='px-0 ' />
        <Col sm='9' className='d-flex flex-column align-items-left px-0 '>
        
          <svg height='50' width='14'  className='d-none d-sm-block' >
            <line x1="0" x2="0" y1="0" y2="100" stroke-linecap="square" stroke="#c5eaff" stroke-width="10"  />
          </svg>
          <img  style={{marginLeft : '-95px'}}  width='189px' height='162px' src={cl3}/>
        
        </Col>
      </Col>


      <Col sm='4' xs='12' className='mt-3 mt-sm-0 px-0 '>
        <p style={{ backgroundColor: 'rgba(255,255,255, 0.5)' }} className='HomeOperationClientTextLn3'>
          Votre projet est étudié par nos équipes et nous vous proposons une{' '}
          <strong className='text-secondary'>
            sélection très fine de consultants
          </strong>{' '}
          qui peuvent intervenir pour vous accompagner.
          <br />
          <br />
          Ces derniers{' '}
          <strong className='text-secondary'>
            vous répondront avec une méthodologie, une roadmap et un budget
          </strong>
          . Vous sélectionnez ensuite avec qui vous souhaitez travailler.
        </p>

        
      </Col>
    </Row>

 {/************************  Ligne 4  ******************************/}    
    <Row className='d-flex justify-content-center px-0 '>
    
      <Col sm='4' xs='12' className='d-flex  justify-content-center  justify-content-sm-end  mt-5 mt-sm-auto'>
        <Col sm='3' className='d-none d-sm-block px-0 ' />
        <Col sm='9' className='d-flex justify-content-center align-items-sm-end px-0 '>
          <span>
            <svg style={{marginBottom: '50px'}} height='178' width='5'  className='d-none d-sm-block' >
              <line x1="0" x2="0" y1="0" y2="300" stroke-linecap="square" stroke="#c5eaff" stroke-width="10"  />
            </svg>
          </span>
          <svg className='mt-auto d-none d-sm-block ' height='5'  style={{marginBottom: '50px'}} >
              <line  x1="0" x2="500" y1="0" y2="0" stroke-linecap="square" stroke="#c5eaff" stroke-width="10"  />
          </svg>
          <img className='HomeOperationClientPicLn4 mt-auto' height="160" width="auto" src={cl4}/>
        </Col>
      </Col>
      

      <Col sm='4' xs='12' className='d-flex justify-content-center  justify-content-sm-start mt-3 mt-sm-auto px-0 '>
        <p className='HomeOperationClientTextLn4' style={{ backgroundColor: 'rgba(255,255,255, 0.5)'}}>
          <strong className='text-secondary'>Le projet peut commencer</strong>
          ,<br />
          en utilisant les fonctionnalités
          <br />
          d'échange et de suivi de BeAdvize.
        </p>
      </Col>

    </Row>

 {/************************  Ligne 5  ******************************/}
    <Row className='d-flex justify-content-center'>
      <Col sm='4' xs='12' className='d-flex flex-column align-items-center  mt-5 mt-sm-auto'>
        <svg className='d-none d-sm-block ' height='130' width='14'  >
         <line x1="0" x2="0" y1="0" y2="150" stroke-linecap="square" stroke="#c5eaff" stroke-width="10"  />
        </svg>
        <img   height="auto" width="287" src={cl5}/>
      </Col>
      <Col xs='12' className='text-center mt-3'>
        <p style={{ backgroundColor: 'rgba(255,255,255, 0.5)' }}>
          Une fois le projet terminé, vous{' '}
          <strong className='text-secondary'>validez la livraison</strong> du
          projet
          <br />
          et{' '}
          <strong className='text-secondary'>
            évaluez la prestation du consultant.
          </strong>
        </p>
      </Col>
    </Row>
  </>
);



// WEBPACK FOOTER //
// ./src/components/HomePage/HomeOperation/HomeOperationClient.tsx